<template>
  <v-row align="center" justify="space-between" v-if="!openInModal">
    <div sm="1" class="px-0">
      <v-icon
        @click="$router.go(-1)"
        class="pointer"
        :data-test-id="`${dataTestId}__back-to-all-archives-icon`"
      >
        arrow_back_ios
      </v-icon>
    </div>
    <div>
      <v-row>
        <x-button
          @click="downloadFile"
          color="#58e2c2"
          buttonText="Download"
          :data-test-id="`${dataTestId}__download-archive-btn`"
        />
        <x-button
          class="ml-2"
          @click="chooseOperation"
          color="#58e2c2"
          :data-test-id="`${dataTestId}__export-restore-archive-btn`"
          :buttonText="operationType"
        />
        <ExportOptionsModal
          v-if="dialogState"
          :operationType="operationType"
          :exportJobInProgress="loadingState"
          @closeDialog="toggleExportModal"
          @triggerExport="restoreArchive"
        />
        <x-button
          v-if="!isTeams"
          class="ml-2"
          color="#58e2c2"
          buttonText="Versions"
          :data-test-id="`${dataTestId}__show-versions-btn`"
          @click="openVersionModal"
        />
      </v-row>
    </div>
    <loader v-if="loadingState" />
  </v-row>
</template>
<script>
import EventBus from '@/EventBus';
import VaultDataService from '@/services/VaultDataService';
import DownloadService from '@/services/DownloadService';
import { CancelToken } from 'axios';
import ExportOptionsModal from './ExportOptionsModal/ExportOptionsModal';
const downloadWaitTime = 30000;
export default {
  name: 'ActionButtons',
  props: {
    openInModal: Boolean,
    metaData: Object,
    archiveId: String,
    version: String,
    type: String,
    metaArchiveId: String,
    isTeams: Boolean,
    sourceType: String,
    dataTestId: String
  },

  data() {
    return {
      loadingState: false,
      dialogState: false
    };
  },

  components: { ExportOptionsModal },
  computed: {
    operationType() {
      return this.isTeams ? 'Export' : 'Restore';
    },
    isOrgOnboarded() {
      return this.onboardingStatus === this.$enums.onboardingStatus.done;
    }
  },

  methods: {
    async downloadFile() {
      const source = CancelToken.source();
      try {
        this.loadingState = true;
        setTimeout(() => {
          if (this.loadingState) {
            source.cancel(this.$message.DOWNLOADING_FILE_TAKING_TIME);
          }
        }, downloadWaitTime);
        let response;
        if (!this.isTeams) {
          response = await VaultDataService.getConnectorArchive(
            {
              archiveId: this.archiveId,
              version: this.version,
              format: 'ORIGINAL',
              type: this.openInModal
                ? 'DISCOVERY'
                : this.type === 'yourArchives'
                ? 'yourArchives'
                : 'ORG'
            },
            source.token
          );
        } else {
          response = await this.$services.vaultData.donwloadMultipleArchive(
            {
              type: this.type,
              archives: [
                {
                  itemId: this.$route.query.archiveId,
                  version: 1,
                  sourceType: 'o365_teams'
                }
              ]
            },
            undefined,
            source.token
          );
        }
        if (response) {
          DownloadService.downloadAFile({
            response,
            fileName: this.metaData.fileName,
            fileType: this.metaData.fileExtension || '.zip'
          });
        }
      } catch (error) {
        // eslint-disable-next-line
        this.snackbar('error', error.message || error, 10000);
      } finally {
        this.loadingState = false;
      }
    },
    async restoreArchive(exportTo) {
      try {
        this.loadingState = true;

        const restoreArchiveObject = {};
        const currentConnector = this.connectorArchiveNameMap(
          this.$route.params.connectorType.toUpperCase()
        );
        restoreArchiveObject[this.sourceType || currentConnector?.id] = [
          this.$route.query.archiveId
        ];

        const response = await this.$services.vaultData.restoreArchiveFile({
          type: this.type,
          archives: restoreArchiveObject,
          exportTo: exportTo || this.sourceType,
          action: this.operationType.toLowerCase()
        });

        const parsedResponse = this.parseResponse(response);
        if (parsedResponse) {
          const connectorName =
            this.connectorArchiveNameMap(exportTo || this.sourceType)?.title ||
            '';

          this.snackbar(
            'success',
            this.operationType === 'Export'
              ? this.$message.EXPORT_QUEUED(connectorName)
              : this.$message.QUEUED
          );
          if (this.operationType === 'Export') {
            this.toggleExportModal();
          }
        } else {
          this.snackbar('error', 'Something went wrong');
        }
      } catch (error) {
        if (
          error?.response?.data?.errors?.[0]?.message ===
          'Your previous request is already in progress!'
        ) {
          this.snackbar('info', error?.response?.data?.errors?.[0]?.message);
        } else {
          this.snackbar('error', error);
        }
      } finally {
        this.loadingState = false;
      }
    },
    async openVersionModal() {
      EventBus.$emit('OPEN_DIALOGUE', true);
    },
    toggleExportModal() {
      this.dialogState = !this.dialogState;
    },
    chooseOperation() {
      if (!this.isOrgOnboarded) {
        this.snackbar(
          'info',
          this.$message.ACTION_RESTRICTION_WHILE_ONBOARDING
        );
        return;
      }

      if (this.operationType === 'Restore') {
        this.restoreArchive();
        return;
      }

      this.toggleExportModal();
    }
  }
};
</script>
